<div class="controls-container">

  @if (allowMockData) {
  <via-email-icon [emailType]="'birthday'" />

  <mat-slide-toggle
    class="example-margin"
    [checked]="isMockData"
    (change)="onMockDataToggle($event)">
    Mock Data
  </mat-slide-toggle>
  }

  <mat-slide-toggle
    class="example-margin"
    [checked]="isEditMode"
    (change)="onEditModeToggle($event)">
    Edit Dashboard
  </mat-slide-toggle>

  <button
    class="control-button"
    (click)="showConfig.emit()">
    Configure
  </button>
</div>
